export default __webpack_public_path__ + "static/media/0000..0007.6b8cfc04.png";